<template>
    <div class="row">
        <div class="col-md-6 pb-2">
            <vue-ctk-date-time-picker v-model="currentDate" locale="sv" :only-date="true" date-format="YYYY-MM-DD" format="YYYY-MM-DD" formatted="YYYY-MM-DD" label="Välj datum" ></vue-ctk-date-time-picker>
            <input type="hidden" name="date[]" :input="currentDate" :change="doFilter">
        </div>
    </div>
<!--    <div class="row">-->

<!--    </div>-->
<!--    <div class="d-flex -mx-2">-->
<!--        <div class="form-group w-1/2 px-2">-->
<!--            <input class="mb-1 pr-1" type="text" v-model="filterText" @keyup.enter="doFilter" placeholder="Sök terapeut...">-->
<!--            <button class="btn bg-primary" @click.prevent="doFilter">Sök</button>-->
<!--            <button class="btn bg-grey-darkest" @click.prevent="resetFilter">Återställ</button>-->
<!--        </div>-->

<!--    </div>-->
</template>

<script>
    export default {
        name: "TableFilter",
        props: ['date'],
        data() {
            return {
                filterText: '',
                currentDate: '',
            }
        },
        methods: {
            doFilter() {
                this.$eventHub.$emit('filter-set', {'filterText': this.filterText, 'date': this.currentDate});
            },
            resetFilter() {
                this.filterText = '';
                this.currentDate = '';
                this.$eventHub.$emit('filter-reset');
            }
        },
        mounted() {
            this.currentDate = this.date;
        },
        watch: {
            currentDate: function () {
                this.$eventHub.$emit('filter-set', {'filterText': this.filterText, 'date': this.currentDate});
            }
        }
    }
</script>

<style scoped>

</style>